<template>
  <b-container>
    <Breadcrumbs crumbString="Creative Services,Illustration"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS has a very talented group of illustrators who work with all media and illustration styles. They have the skills to clearly communicate your interpretive concepts.
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img illustration-full-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration01.jpg') + ')'}"></div>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                  <div class="img illustration-full-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration06.jpg') + ')'}"></div>
                </b-col>
                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                  <div class="img illustration-full-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration07.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img illustration-58-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration03.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img illustration-full-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration02.jpg') + ')'}"></div>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img illustration-73-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration04.jpg') + ')'}"></div>
                </b-col>
                <b-col class="col-12 image-pod">
                  <div class="img illustration-58-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/illustration/interpretive-illustration05.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Illustration'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/creativeServices/Illustration.vue